// @flow

import React, { Component } from 'react';
import * as d3 from 'd3';

import regression from 'regression';

import LocatedCircles from '../LocatedCircles/LocatedCircles';

import './ScatterPlot.css';

const margin = { top: 20, right: 20, bottom: 30, left: 30 };

class ScatterPlot extends Component {
  node: Object;
  update: Function;
  xScale: Function;
  yScale: Function;
  chartWidth: number;
  chartHeight: number;

  constructor(props: Object) {
    super(props);
    this.update = this.update.bind(this);
  }

  componentDidMount() {
    this.update();
  }
  componentDidUpdate() {
    this.update();
  }

  update() {
    const { xMeasure, yMeasure, data } = this.props;
    const xAxis = xMeasure.key;
    const yAxis = yMeasure.key;
    const fullData = data.filter(
      d => d[xAxis] !== null && d[yAxis] !== null && !isNaN(d[xAxis]) && !isNaN(d[yAxis]),
    );

    const xScale = d3
      .scaleLinear()
      .domain([0, xMeasure.maxScatterScaleValue])
      .range([0, this.chartWidth]);

    const yScale = d3
      .scaleLinear()
      .domain([0, yMeasure.maxScatterScaleValue])
      .range([this.chartHeight, 0]);

    const regressionData = fullData.map(d => [d[xAxis], d[yAxis]]);
    const model = regression.linear(regressionData, {
      order: 1,
      precision: 12,
    });
    const [x1, y1] = model.predict(d3.min(fullData.map(d => d[xAxis])));
    const [x2, y2] = model.predict(d3.max(fullData.map(d => d[xAxis])));

    const node = d3.select(this.node);

    node.selectAll('.axis').remove();
    node.selectAll('.axis-label').remove();
    node.selectAll('.regression-line').remove();

    node
      .append('g')
      .attr('transform', `translate(${margin.left}, ${this.props.height - margin.bottom})`)
      .attr('class', 'x-axis axis')
      .call(
        d3
          .axisBottom(xScale)
          .ticks(4)
          .tickFormat(xMeasure.formater)
          .tickSizeOuter(0)
          .tickSizeInner(3),
      );

    node
      .append('g')
      .attr('transform', `translate(${margin.left}, ${margin.top})`)
      .attr('class', 'y-axis axis')
      .call(
        d3
          .axisLeft(yScale)
          .ticks(4)
          .tickFormat(yMeasure.formater)
          .tickSizeOuter(0)
          .tickSizeInner(3),
      );

    // label for x axis
    node
      .append('text')
      .attr(
        'transform',
        `translate(${margin.left + this.chartWidth / 2}, ${this.chartHeight +
          margin.top +
          2 * margin.bottom / 3})`,
      )
      .attr('class', 'x-axis-label axis-label')
      .style('text-anchor', 'middle')
      .text(xMeasure.label);

    // label for y axis
    node
      .append('text')
      .attr('transform', 'rotate(-90)')
      .attr('y', 0)
      .attr('x', 0 - margin.top - this.chartHeight / 2)
      .attr('class', 'y-axis-label axis-label')
      .attr('dy', '1em')
      .style('text-anchor', 'middle')
      .text(yMeasure.label);

    // regression line
    if (!isNaN(x1) && !isNaN(x2) && !isNaN(y1) && !isNaN(y2)) {
      node
        .append('g')
        .attr('transform', `translate(${margin.left}, ${margin.top})`)
        .attr('class', 'regression-line')
        .append('line')
        .attr('x1', xScale(x1))
        .attr('y1', yScale(y1))
        .attr('x2', xScale(x2))
        .attr('y2', yScale(y2));
    }
  }

  render() {
    const { xMeasure, yMeasure, data, width, height } = this.props;
    const xAxis = xMeasure.key;
    const yAxis = yMeasure.key;

    this.chartHeight = height - margin.bottom - margin.top;
    this.chartWidth = width - margin.left - margin.right;

    const xScale = d3
      .scaleLinear()
      .domain([0, xMeasure.maxScatterScaleValue])
      .range([0, this.chartWidth]);

    const yScale = d3
      .scaleLinear()
      .domain([0, yMeasure.maxScatterScaleValue])
      .range([this.chartHeight, 0]);

    const calculateLocation = d => {
      return [xScale(d[xAxis]), yScale(d[yAxis])];
    };

    const fullData = data.filter(d => d[xAxis] !== null && d[yAxis] != null);

    return (
      <g className="ScatterPlot" ref={node => (this.node = node)}>
        <g transform={`translate(${margin.left}, ${margin.top})`}>
          <LocatedCircles
            width={width}
            buildTooltip={this.props.buildTooltip}
            calculateArea={this.props.calculateArea}
            calculateLocation={calculateLocation}
            locations={fullData}
            keyFunction={this.props.keyFunction}
            calculateFill={this.props.calculateFill}
            calculateStroke={this.props.calculateStroke}
            calculateStrokeWidth={this.props.calculateStrokeWidth}
            onSelection={this.props.onSelection}
            scale="1"
          />
        </g>
      </g>
    );
  }
}

export default ScatterPlot;



// WEBPACK FOOTER //
// ./src/components/ScatterPlot/ScatterPlot.js